import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import "../../../styles/hydiene-system/hydiene.css";
import "../../../styles/hydiene-system/hygiene-open-form.css";
import HelmetWrapper from "../../../HelmetWrapper";
import { fetchHygineTasksLogsDataV2 } from "../../../redux/hygiene-reducers/hygieneSlice";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts";
import ValidateByMobile from "./ValidateByMobile";
import HygineTaskOverview from "./hygine-task-overview/HygineTaskOverview";

const HygineFormStructure = ({ userInfoData, mobileNumber }) => {
  const dispatch = useDispatch();
  const { hygineTaskLogsLoadingV2, hygineTaskLogsErrorV2, hygineTaskLogsV2 } =
    useSelector((state) => state.hygiene);
  const { userDetailsByMobile } = useSelector((state) => state.api);

  const accountType =
    userDetailsByMobile?.data?.[0]?.account_type ||
    userInfoData?.account_type ||
    "";
  const gymId =
    userDetailsByMobile?.data?.[0]?.gym_id || userInfoData?.gym_id || "";
  const taskDate = FORMATTED_TODAY_DATE_YYYYMMDD;
  const token =
    userInfoData?.token || userDetailsByMobile?.data?.[0]?.token || "";

  const [currentTaskIndex, setCurrentTaskIndex] = useState(0);
  const iniFilters = {
    // page: currentTaskIndex + 1,
    // limit: 1 || 1000,
    // task_date: taskDate,
    task_date_from: taskDate,
    task_date_to: taskDate,
    stakeholders: accountType || "",
    gym_id: gymId || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [taskDatas, setTaskDatas] = useState({});
  // const [taskDataPages, setTaskDataPages] = useState([]);

  const iniMemStatus = {
    isShowForm: false,
    errorMessage: "",
    isShowTasksForm: false,
  };
  const [memberStatus, setMemberStatus] = useState(iniMemStatus);
  const iniAllTasks =
    taskDatas?.task_details?.map((task) => ({
      taskUid: task.uid || "",
      taskId: task.task_id || "",
      taskName: task.task_name || "",
      selectedTaskStatus:
        task.task_status && task.task_status_id
          ? {
              label: task.task_status,
              value: task.task_status_id,
              info: task,
            }
          : "",
      taskDescription: task.description || "",
      taskStatus: task?.status || "",
      task: task,
      taskImages:
        task.images_arr?.length > 0
          ? task.images_arr?.map((img) => [{ data_url: img, image_url: img }])
          : [...Array(Number(task.img_quantity) || 0)].map(() => []),
      taskVideos:
        task.video_arr?.length > 0
          ? task.video_arr?.map((vid) => [{ data_url: vid, image_url: vid }])
          : [...Array(Number(task.vid_quantity) || 0)].map(() => []),
    })) || [];
  const iniFormValues = {
    mobileNumber: mobileNumber || "",
    allTasks: iniAllTasks,
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [memberFetchedData, setMemberFetchedData] = useState(null);
  const [isFetchUser, setIsFetchUser] = useState(false);

  const onChangeInput = (e, taskIndex = null) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setFormValues((prev) => {
      if (name === "mobileNumber") {
        if (value.length > 10) return prev;

        setCurrentTaskIndex(0);
        localStorage.removeItem("hygiene_form_mobile_number");

        return {
          ...prev,
          mobileNumber: value,
          allTasks: iniAllTasks || [],
        };
      }

      if (taskIndex !== null) {
        const updatedTasks = [...prev.allTasks];
        updatedTasks[taskIndex] = {
          ...updatedTasks[taskIndex],
          [name]: type === "checkbox" ? checked : file || value,
        };

        return { ...prev, allTasks: updatedTasks };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  async function getHygieneTasks(filters, token) {
    try {
      dispatch(
        fetchHygineTasksLogsDataV2({
          filters,
          token: token || "",
        })
      );
    } catch (error) {
      console.error("Error fetching hygiene tasks:", error);
    }
  }

  useEffect(() => {
    getHygieneTasks(filters, token);
  }, [filters, token]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      stakeholders: accountType,
      gym_id: gymId,
    }));
  }, [gymId, accountType]);

  useEffect(() => {
    if (
      !hygineTaskLogsLoadingV2 &&
      !hygineTaskLogsErrorV2 &&
      hygineTaskLogsV2?.status &&
      hygineTaskLogsV2?.data
    ) {
      const hygineTask = hygineTaskLogsV2.data;

      setTaskDatas(hygineTask);
      // setTaskDataPages(hygineTaskLogsV2?.pagination || []);
    } else {
      setTaskDatas({});
      // setTaskDataPages([]);
    }
  }, [hygineTaskLogsLoadingV2, hygineTaskLogsErrorV2, hygineTaskLogsV2]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: currentTaskIndex + 1,
    }));
  }, [currentTaskIndex]);

  return (
    <HelmetWrapper title="WTF: daily operation checklist form">
      <Container
        className="bg-cloud-k gobal-container open-form-without-parent px-0"
        fluid
      >
        <div className="gym-task-container">
          <div className="form-container open-form-page-container mod-with-images">
            <form className="formContainer">
              {memberStatus.isShowTasksForm ? (
                <HygineTaskOverview
                  userInfoData={memberFetchedData}
                  setMemberStatus={setMemberStatus}
                  // taskDate={filters.task_date}
                  prevFilters={filters}
                />
              ) : (
                <ValidateByMobile
                  mobileNumber={mobileNumber}
                  iniFormValues={iniFormValues}
                  formValues={formValues}
                  setFormValues={setFormValues}
                  formErrors={formErrors}
                  memberStatus={memberStatus}
                  setMemberStatus={setMemberStatus}
                  onChangeInput={onChangeInput}
                  setCurrentTaskIndex={setCurrentTaskIndex}
                  memberFetchedData={memberFetchedData}
                  setMemberFetchedData={setMemberFetchedData}
                  iniMemStatus={iniMemStatus}
                  isFetchUser={isFetchUser}
                  setIsFetchUser={setIsFetchUser}
                  token={token}
                />
              )}
            </form>
          </div>
        </div>
      </Container>
    </HelmetWrapper>
  );
};

export default HygineFormStructure;
